module.exports = __webpack_public_path__ + "img/IMG_8943.d581f530.jpg";